export default __webpack_public_path__ + "static/media/legaldesign-law+design+humans.169920a6.svg";